import { Screen, useNavigation } from '@bonanza-social/navigation';
import { memo, useEffect } from 'react';
import History from '../components/History/History';
import { HistoryType } from '../state/shared/history.types';
import { useTranslation } from '@bonanza-social/i18n';

function TransactionHistoryScreen() {
  const navigation = useNavigation();
  const { t } = useTranslation('account');

  useEffect(() => {
    navigation.setOptions({ title: t('transactionHistoryTitle') });
  }, [navigation, t]);

  return (
    <Screen paddingHorizontal="space-0">
      <History type={HistoryType.Transactions} />
    </Screen>
  );
}

export default memo(TransactionHistoryScreen);
